var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"collect_box"},[_vm._v(" 请前往APP端进行操作 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }